export const setSessionStorage = (key, value, type = '') => {
  if (type !== 'signature') {
    localStorage.setItem(key, JSON.stringify(value));
  }
  if (window !== 'undefined') {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
};

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
};

export const getSessionStorage = (key) => {
  const value = JSON.parse(localStorage.getItem(key));
  if (window !== 'undefined') {
    if (window.sessionStorage.getItem(key) !== 'undefined') {
      return JSON.parse(window.sessionStorage.getItem(key)) || value;
    } else {
      return value;
    }
  } else {
    return value;
  }
};

export const getLocalStorage = (key) => {
  const value = JSON.parse(localStorage.getItem(key));
  if (window !== 'undefined') {
    if (window.localStorage.getItem(key) !== 'undefined') {
      return JSON.parse(window.localStorage.getItem(key)) || value;
    } else {
      return value;
    }
  } else {
    return value;
  }
};

export const setKeyCloakRealmOnLS = (realm) => {
  if (realm) {
    setSessionStorage('kcRealm', realm);
    localStorage.setItem('kcRealm', JSON.stringify(realm));
  }
};

export const getKeyCloakRealmFromLS = () => {
  const realmName = getSessionStorage('kcRealm');
  return realmName;
};

export const removeKeyCloakRealmOnLS = () => {
  removeSessionStorage('kcRealm');
};

export const setUserId = (key, value) => {
  localStorage.setItem(key, value);
  if (window !== 'undefined') {
    window.sessionStorage.setItem(key, value);
  }
};

export const getUserId = (key) => {
  if (window !== 'undefined') {
    return JSON.parse(window.sessionStorage.getItem(key));
  } else {
    return JSON.parse(localStorage.getItem(key));
  }
};
